import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { IlastUpdateBase, ISecurityLogBase, ISecurityMonitoringData, ISecurityMonitoringState } from "types/models/security-monitoring";
import { RootState } from "types/reducer";

const initialState: ISecurityMonitoringState = {
    security_monitoring : [ 
        {
            partition_key:"",
            log_name: "",
            column_name: [],
            process_files: [],
            board_maker: "",
            brand_name: "",
            crt_date: "",
            mac: "",
            product: "",
            udid: "",
        }
    ],
    security_log:{} as ISecurityLogBase,
    security_log_upload: {
        log_name: "",
        column_name: [],
    },
    last_update: {} as IlastUpdateBase,
    job_process: null
}


const SecurityMonitoringSlice = createSlice({
    name: "security_monitoring",
    initialState,
    reducers: {
        fetchMetadata(
            state
        ) {},
        fetchMetadataSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<ISecurityMonitoringData[]>
        ) {
            state.security_monitoring = action.payload
        },
        fetchLogData(
            state
        ) {},
        fetchLogDataSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ) {
            state.security_log = action.payload;
        },
        fetchLogDataFilter(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        fetchLogDataFilterSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){
            state.security_log = action.payload;
        },
        fetchDataLogName(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<ISecurityMonitoringData[]>
        ){
        },
        fetchDataLogNameSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<ISecurityMonitoringData[]>
        ) {
            state.security_monitoring = action.payload
        },
        editLogManagement(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ) {
        },
        editLogManagementSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ) {},
        editDisplayLogManagement( 
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>)
        {},
        editDisplayLogManagementSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        deleteLogManagement(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        deleteLogManagementSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ) {},
        deleteLog(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        deleteLogSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        fetchReloadData(
            state
        ) {},
        fetchReloadDataSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ) {
            state.security_log = action.payload;
        },
        exportDataLogName(
            state: Draft<ISecurityMonitoringState>,
            action:  PayloadAction<any>
        ) {},
        exportDataLogNameSuccess(
            state: Draft<ISecurityMonitoringState>,
            action:  PayloadAction<any>
        ) {
        },
        uploadFileLog(
            state: Draft<ISecurityMonitoringState>,
            action:  PayloadAction<any>
        ) {},
        uploadFileLogSuccess (
            state: Draft<ISecurityMonitoringState>,
            action:  PayloadAction<any>
        ) {
            state.security_log_upload = action.payload
        },
        createLogData(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        createLogDataSuccess(
            state: Draft<ISecurityMonitoringState>,
            action: PayloadAction<any>
        ){},
        fetchLatestUpdate(state){},
        fetchLatestUpdateSuccess(state: Draft<ISecurityMonitoringState>, action: PayloadAction<any>){
            state.last_update = action.payload
        },
        statusProgressJob(state: Draft<ISecurityMonitoringState>, action: PayloadAction<any>){
            state.job_process = action.payload;
        }
    }
})


// Actions
export const fetchSecurityMonitoring = SecurityMonitoringSlice.actions.fetchMetadata;
export const fetchSecurityMonitoringSuccess = SecurityMonitoringSlice.actions.fetchMetadataSuccess;

export const fetchLogMonitoring = SecurityMonitoringSlice.actions.fetchLogData;
export const fetchLogMonitoringSuccess = SecurityMonitoringSlice.actions.fetchLogDataSuccess;

export const fetchLogMonitoringFilter = SecurityMonitoringSlice.actions.fetchLogDataFilter;
export const fetchLogMonitoringFilterSuccess = SecurityMonitoringSlice.actions.fetchLogDataFilterSuccess;

export const editLogManagement = SecurityMonitoringSlice.actions.editLogManagement;
export const editLogManagementSuccess = SecurityMonitoringSlice.actions.editLogManagementSuccess;

export const editDisplayLogManagement = SecurityMonitoringSlice.actions.editDisplayLogManagement;
export const editDisplayLogManagementSuccess = SecurityMonitoringSlice.actions.editDisplayLogManagementSuccess;

export const deleteLogManagement = SecurityMonitoringSlice.actions.deleteLogManagement;
export const deleteLogManagementSuccess = SecurityMonitoringSlice.actions.deleteLogManagementSuccess;

export const deleteLogId = SecurityMonitoringSlice.actions.deleteLog;
export const deleteLogIdSuccess = SecurityMonitoringSlice.actions.deleteLogSuccess;

export const reloadDataManagement = SecurityMonitoringSlice.actions.fetchReloadData;
export const reloadDataManagementSuccess = SecurityMonitoringSlice.actions.fetchReloadDataSuccess;

export const exportDataLogName = SecurityMonitoringSlice.actions.exportDataLogName;
export const exportDataLogNameSuccess = SecurityMonitoringSlice.actions.exportDataLogNameSuccess;

export const uploadFileLog = SecurityMonitoringSlice.actions.uploadFileLog;
export const uploadFileLogSuccess = SecurityMonitoringSlice.actions.uploadFileLogSuccess;

export const createLogMetadata = SecurityMonitoringSlice.actions.createLogData;
export const createLogMetadataSuccess = SecurityMonitoringSlice.actions.createLogDataSuccess;

export const latestUpdateMetadata = SecurityMonitoringSlice.actions.fetchLatestUpdate;
export const lasestUpdateMetadataSuccess = SecurityMonitoringSlice.actions.fetchLatestUpdateSuccess;

export const statusProgressJob = SecurityMonitoringSlice.actions.statusProgressJob;

// Selectors
export const getDataSecurityMonitoring = (state: RootState) => state.security_monitoring.security_monitoring
export const getLogSecurityMonitoring = (state: RootState) => state.security_monitoring.security_log
export const getDataUploadLog = (state: RootState) => state.security_monitoring.security_log_upload
export const getLastUpdate = (state : RootState) => state.security_monitoring.last_update
export const getProcessJob = (state: RootState) => state.security_monitoring.job_process;
// export const getLogNameSecurityMonitoring = (state: RootState)

// Rducer
const SecurityMonitoringReducer = SecurityMonitoringSlice.reducer;
export default SecurityMonitoringReducer;